import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ClientApi, OrgMappingLookup } from 'src/app/client-api.service';

@Injectable({
  providedIn: 'root'
})
export class OrgMappingLookupService {
  private orgMappingLookups = new BehaviorSubject<OrgMappingLookup[]>([]);
  readonly orgMappingLookups$ = this.orgMappingLookups.asObservable();

  constructor(private apiClient: ClientApi) { }
 
  deleteOrgMappingLookup(id: number) {
    return this.apiClient.deleteOrgMappingLookup(id);
  }

  setOrgMappingLookups() {
    this.getOrgMappingLookups()      
        .subscribe(res => this.orgMappingLookups.next(res));
  }

  getOrgMappingLookups() {
    return this.apiClient.getOrgMappingLookups();
  }

  getOrgMappingLookup(id: number) {
    return this.apiClient.getOrgMappingLookup(id);
  }               

  putOrgMappingLookup(orgMappingLookup: OrgMappingLookup)
  {
    return this.apiClient.putOrgMappingLookup(orgMappingLookup);
  }
}
